import { Component, forwardRef, Input, OnInit, ViewChild } from "@angular/core";
import { GridComponent } from "app/modules/shared/components/grid/grid.component";

@Component({
  selector: "kl-shipping-address-list",
  templateUrl: "./shipping-address-list.component.html",
  styleUrls: ["./shipping-address-list.component.scss"],
})
export class ShippingAddressListComponent implements OnInit {
  @Input() mode: string;
  @Input() service: string;
  @Input() tabId: string;
  @Input() modalId: string;
  @ViewChild(forwardRef(() => GridComponent), {
    static: true,
  })
  private gridComponent: GridComponent;

  constructor() {}

  ngOnInit() {}
}
